export default {
  wrapper: {
    '& .MuiPopover-popper': {
      border: 'none',
    },
    '& .MuiPopover-paper': {
      backgroundColor: '#fff',
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiInputLabel-root': {
      top: '-6px',
    },
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 12px',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => theme.palette.text.primary,
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays?.gray100,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      color: (theme) => theme.palette.text.primary,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays?.gray100,
      },
    },
    '&.Mui-focusVisible': {
      backgroundColor: (theme) => theme.palette.grays?.gray100,
    },
  },
  radioIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  radioUncheckedIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.grays?.gray300,
  },
  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',
    color: (theme) => theme.palette.blues.primaryBlue,

    '& .MuiSelect-nativeInput': {
      height: '100%',
    },
    '& .MuiInputBase-input': {
      padding: '10px 12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },
    '&:hover': {
      backgroundColor: (theme) => theme.palette.grays.lightestGray,

      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      },
    },
    '&.Mui-focused': {
      color: (theme) => theme.palette.blues.primaryBlue500,

      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
      },
    },
  },

  textfieldWithValue: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
    '& .MuiSvgIcon-root.MuiSelect-iconOutlined': {
      display: 'block',
    },
    '&:hover': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      },
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
      },
    },
  },
};
